<div class="gap-x-6" [ngClass]="{'capability-selected': capability.selected,'optional-capability': !capability.selected}">
  <div class="flex flex-col capability-card p-24 h-200" [ngClass]="{'hoverColor': !capability.selected, 'selected': capability.selected}">
    <div class="flex flex-row justify-between mb-20">
      <div class="mat-headline-5 mb-0 max-limit-per-line">{{capability?.componentIdentifier?.name | titlecase}}</div>
      <div *ngIf="selectable">
        <mat-icon *ngIf="!capability.selected" svgIcon="check_box_outline_blank" class="select-icon icon-md-1 cursor-pointer"
        (click)="toggleSelection()"></mat-icon>
        <mat-icon *ngIf="capability.selected" svgIcon="check_box" class="select-icon icon-md-1 cursor-pointer disabled" 
        (click)="!capability.disabled ? toggleSelection() : null"></mat-icon>
      </div>
    </div>
    <div *ngIf="((capability.name?.length >= 17) && (capability.name.length <= 30)) && capability.description" class="flex mb-12 mat-body-2 fw-400 description">
      {{(capability.description | slice:0:50)+'...'}}
    </div>
    <div *ngIf="(capability.name?.length > 30) && capability.description" class="flex mb-12 mat-body-2 fw-400 description">
      {{(capability.description | slice:0:30)+'...'}}
    </div>
    <div *ngIf="(capability.name?.length < 17) && capability.description" class="flex mb-12 mat-body-2 fw-400 description">
      {{(capability.description | slice:0:100)+'...'}}
    </div>
    <button class="basic-button w-max-content capability-link cursor-pointer mat-subtitle-2 pb-2 pl-0 pr-0 fw-400 mb-0 h-auto" (click)="viewDetails()">{{'SOLUTIONS.VIEW' | transloco}}</button>
  </div>
</div>
